import { Component, Prop } from "vue-property-decorator";
import { LocationDTO } from "@/model/LocationDTO";
import { BaseComponent } from '../base-component';
import { LocationStatsDTO } from '../../model/LocationStatsDTO';
import { InstanceType } from '../../enums/InstanceType';
import { getBoIdMapping } from '../../helpers/boIdMapping';

@Component
export class LocationPreview extends BaseComponent {
	@Prop() location: LocationDTO;
	@Prop() stats: LocationStatsDTO;

	get boIdMapping() {
		return getBoIdMapping(InstanceType.ApartmentLocation, this.location);
	}

	get locationCatalogNo(): string {
		var retVal = this.location.catalogNumber;
		if (this.location.catalogMarketingNumber && this.location.catalogMarketingNumber != "") {
			retVal = this.location.catalogMarketingNumber;
		}

		return retVal;
	}

	get cityFullName(): string {
		var result = this.location.city;
		if (this.location.cityPart) {
			result += ` - ${this.location.cityPart}`;
		}

		return result;
	}
}

export default LocationPreview;
